import OrganizationDetailPage from "@/features/organization/pages/OrganizationDetail";

const OrganizationDetail = () => {
  return <OrganizationDetailPage />;
};

export default OrganizationDetail;
